import EditProfileDrawer from '@/views/components/edit-profile-drawer/index.component'

const UiFeedbackComponent = () => {
  return (
    <>
      <EditProfileDrawer />
    </>
  )
}

export default UiFeedbackComponent
